import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'W1',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M30.67 17.33H28a1.33 1.33 0 1 1 0-2.66h2.67a1.33 1.33 0 1 1 0 2.66zm-5.24-8.87c-.52.52-1.37.52-1.89 0a1.34 1.34 0 0 1 0-1.89l1.89-1.89a1.34 1.34 0 0 1 1.89 0c.52.52.52 1.36 0 1.89l-1.89 1.89zM16 24c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-13.33c-2.95 0-5.33 2.39-5.33 5.33 0 2.95 2.39 5.33 5.33 5.33s5.33-2.39 5.33-5.33c0-2.95-2.38-5.33-5.33-5.33zm0-5.34c-.74 0-1.33-.6-1.33-1.33V1.33a1.33 1.33 0 1 1 2.66 0V4c0 .74-.59 1.33-1.33 1.33zM6.57 8.46L4.69 6.57c-.52-.52-.52-1.36 0-1.89s1.36-.52 1.89 0l1.89 1.89c.52.52.52 1.36 0 1.89-.53.52-1.38.52-1.9 0zM5.33 16c0 .74-.6 1.33-1.33 1.33H1.33a1.33 1.33 0 1 1 0-2.66H4c.74 0 1.33.59 1.33 1.33zm1.24 7.54a1.34 1.34 0 0 1 1.89 0c.52.52.52 1.37 0 1.89l-1.89 1.89c-.52.52-1.36.52-1.89 0a1.34 1.34 0 0 1 0-1.89l1.89-1.89zM16 26.67c.74 0 1.33.6 1.33 1.33v2.67a1.33 1.33 0 1 1-2.66 0V28c0-.74.59-1.33 1.33-1.33zm9.43-3.13l1.89 1.89c.52.52.52 1.37 0 1.89-.52.52-1.37.52-1.89 0l-1.89-1.89a1.34 1.34 0 0 1 0-1.89 1.34 1.34 0 0 1 1.89 0z" }
      })]
    );
  }
};